import React from 'react'

interface ReplyIconProps {
  width?: number
  height?: number
  alt?: string
  rotate?: boolean
  flip?: boolean
}

const ReplyIcon: React.FC<ReplyIconProps> = ({
  width = 24,
  height = 24,
  alt = 'Reply icon',
  rotate = false,
  flip = false,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      aria-label={alt}
      style={{
        transform: rotate ? 'rotate(180deg)' : flip ? 'scaleX(-1)' : undefined,
        minWidth: width,
        minHeight: height,
        flexShrink: 0,
      }}
    >
      <title>{alt}</title>
      <path
        d='M9.99997 8.99977V7.40977C9.99997 6.51977 8.91997 6.06977 8.28997 6.69977L3.69997 11.2898C3.30997 11.6798 3.30997 12.3098 3.69997 12.6998L8.28997 17.2898C8.91997 17.9198 9.99997 17.4798 9.99997 16.5898V14.8998C15 14.8998 18.5 16.4998 21 19.9998C20 14.9998 17 9.99977 9.99997 8.99977Z'
        fill='#474E5E'
      />
    </svg>
  )
}

export default ReplyIcon
